<template>
  <v-autocomplete v-bind="$attrs" v-on="$listeners" class="autocomplete">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "AAutocomplete",
};
</script>

<style scoped>
.autocomplete {
  font-family: 'Noto Sans JP' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;  
  align-items: center !important;
  border-radius: 0 !important;
}
.autocomplete /deep/ .v-text-field input {
    flex: 1 auto;
    line-height: 20px;
    padding: 8px 0 8px;
    max-width: 100%;
    min-width: 0px;
    width: 100%;
    font-size: 14px !important; 
}
.autocomplete /deep/ .v-label {
    font-size: 16px !important;
    line-height: 16px !important;
    min-height: 8px;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.autocomplete /deep/ .v-input__prepend-outer {
  align-self: flex-start !important;
}
.autocomplete /deep/ .v-input__slot {
  min-height: 52px !important;
}
</style>